var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgTime(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19a9 9 0 100-18 9 9 0 000 18z",
    fill: "#4596E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1v18a9 9 0 110-18z",
    fill: "#66B3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.896 10a7.892 7.892 0 11-15.783-.05 7.892 7.892 0 0115.783.05z",
    fill: "#F2F9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.009 3.88L3.791 14.87A7.895 7.895 0 0115.01 3.88z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.371 14.53a.825.825 0 01-.587-.242L9.61 11.16a1.721 1.721 0 01-.507-1.214V3.657a.839.839 0 011.677 0v6.29l3.183 3.146a.84.84 0 01-.59 1.44v-.004zM3.425 10.75a.749.749 0 100-1.498.749.749 0 000 1.498zM9.999 17.326a.749.749 0 100-1.498.749.749 0 000 1.498zM16.577 10.75a.749.749 0 100-1.498.749.749 0 000 1.498z",
    fill: "#4596E6"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h18v18H0z"
  })))));
}
export default SvgTime;